import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../Helper/Loader";
import Breadcrumbs from "../../../Helper/Breadcrumbs";
import config from "../../../../config";
import { Form, Button } from "react-bootstrap";
import { FaMinusCircle, FaPlus } from "react-icons/fa";

const FaqcontentForm = (props) => {
  const history = useHistory();
  const propsState = props.history.location.state;
  const editMode = (propsState && propsState.editMode) || false;

  const [form, setForm] = useState({
    page_type: null,
    mandap: null,
    faqs: [{ question: "", answer: "" }],
    is_active: true,
  });

  const [mandaps, setMandaps] = useState([]);
  const [nextUrl, setNextUrl] = useState(null); // 🔹 for pagination
  const [isLoadingMandaps, setIsLoadingMandaps] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [overlay, setOverlay] = useState(false);

  const pageOptions = [
    { value: "home", label: "Home Page" },
    { value: "faqs", label: "FAQ Page" },
    { value: "mandap", label: "Mandap Page" },
  ];

  const toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 1500,
    hideProgressBar: true,
  };

  const breadcrumbData = [
    { title: "FAQs", href: "/seobook/faqcontent" },
    { title: editMode ? "Edit FAQs" : "Create FAQs", href: "#" },
  ];

  // 🔹 Load first page of mandaps
const fetchMandaps = async (url = `${config.service}/masters/guest/vendor_mandap_all/`) => {
  setIsLoadingMandaps(true); // 🔹 loader for mandap dropdown
  try {
    const resp = await axios.get(url, {
      headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
    });

    const options = resp.data.map((m) => ({
      value: m.id,
      label: m.mandap_name,
    }));

    setMandaps(options);
  } catch (err) {
    toast.error("Failed to load mandaps", toastAttr);
  } finally {
    setIsLoadingMandaps(false); // 🔹 stop loader
  }
};




  useEffect(() => {
    fetchMandaps();
  }, []);

  // 🔹 Detect scroll inside react-select menu for infinite loading
  const handleScroll = (event) => {
    const bottom =
      event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;
    if (bottom && nextUrl) {
      fetchMandaps(nextUrl);
    }
  };
console.log("editMode",editMode,"propsState",propsState);
  // 🔹 Load existing data in edit mode
  // 🔹 Load existing data in edit mode
// useEffect(() => {
//   if (editMode && propsState && propsState.page_type) {
//     setLoader(true);
//     axios
//       .get(`${config.service}/faqs/?page_type=${propsState.page_type}`, {
//         headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
//       })
//       .then((resp) => {
//         // Normalize mandap and faqs to match serializer expectations
//         const data = resp.data;
//         const normalizedFaqs = (data.faqs || []).map(f => ({
//           question: f.question || "",
//           answer: f.answer || "",
//         }));
//         console.log("normalizedFaqs",data);
//         setForm({
//           page_type: data.page_type || null,
//           mandap: data.mandap ?? null, // allow null
//           is_active: !!data.is_active, // ensure boolean
//           faqs: normalizedFaqs.length ? normalizedFaqs : [{ question: "", answer: "" }],
//         });
//         setLoader(false);
//       })
//       .catch(() => setLoader(false));
//   } else {
//     setLoader(false);
//   }
// }, [editMode, propsState]);
useEffect(() => {
  if (editMode && propsState && propsState.page_type) {
    setLoader(true);

    const params = new URLSearchParams({ page_type: propsState.page_type });
    if (propsState.mandap) params.append("mandap", propsState.mandap);

    axios
      .get(`${config.service}/faqs/?${params.toString()}`, {
        headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
      })
      .then((resp) => {
        const data = resp.data;
        const normalizedFaqs = (data.faqs || []).map(f => ({
          question: f.question || "",
          answer: f.answer || "",
        }));

        setForm({
          page_type: data.page_type || null,
          mandap: data.mandap ? Number(data.mandap) : null, // ✅ number
          is_active: !!data.is_active,
          faqs: normalizedFaqs.length ? normalizedFaqs : [{ question: "", answer: "" }],
        });

        setLoader(false);
      })
      .catch(() => setLoader(false));
  } else {
    setLoader(false);
  }
}, [editMode, propsState]);


// 🔹 Save Form
const saveForm = async () => {
  const newErrors = findErrors();
  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    toast.error("Please fill all required fields", toastAttr);
    return;
  }

  setLoader(true);

  // Normalize payload to match serializer
  const payload = {
    page_type: form.page_type || null,
    mandap: form.mandap ?? null,
    is_active: !!form.is_active, // ensure boolean
    faqs: form.faqs.map(f => ({
      question: f.question || "",
      answer: f.answer || "",
    })),
  };

  const url = editMode
    ? `${config.service}/faqs/bulk-update/`
    : `${config.service}/faqs/bulk-create/`;
  const method = editMode ? "put" : "post";

  axios({
    url,
    method,
    headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
    data: payload,
  })
    .then(() => {
      toast.success("FAQs saved successfully", toastAttr);
      history.push("/seobook/faqcontent");
      setLoader(false);
    })
    .catch((err) => {
      console.error("Save FAQ error:", err.response || err);
      toast.error("Error saving FAQs", toastAttr);
      setLoader(false);
    });
};

  const setLoader = (val) => {
    setLoading(val);
    setOverlay(val);
  };

 const handleInput = (key, value) => {
  const newValue = key === "mandap" ? (value !== null ? Number(value) : null) : value;
  setForm({ ...form, [key]: newValue });
  if (errors[key]) setErrors({ ...errors, [key]: null });
};


  const handleFaqChange = (index, key, value) => {
    const updatedFaqs = [...form.faqs];
    updatedFaqs[index][key] = value;
    setForm({ ...form, faqs: updatedFaqs });
  };

  const addFaq = () => {
    setForm({ ...form, faqs: [...form.faqs, { question: "", answer: "" }] });
  };

  const removeFaq = (index) => {
    const updatedFaqs = form.faqs.filter((_, i) => i !== index);
    setForm({ ...form, faqs: updatedFaqs });
  };

  const findErrors = () => {
    const newErrors = {};
    if (!form.page_type) newErrors.page_type = "Select page type";
    if (form.page_type === "mandap" && (form.mandap === null || form.mandap === undefined))
  newErrors.mandap = "Select mandap";

    
    form.faqs.forEach((f, idx) => {
      if (!f.question || !f.answer)
        newErrors[`faq_${idx}`] = "Question and answer are required";
    });

    return newErrors;
  };

  // const saveForm = async () => {
  //   const newErrors = findErrors();
  //   if (Object.keys(newErrors).length > 0) {
  //     setErrors(newErrors);
  //     toast.error("Please fill all required fields", toastAttr);
  //     return;
  //   }

  //   setLoader(true);

  //   const url = editMode
  //     ? `${config.service}/faqs/bulk-update/`
  //     : `${config.service}/faqs/`;

  //   const method = editMode ? "put" : "post";

  //   axios({
  //     url,
  //     method,
  //     headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
  //     data: form,
  //   })
  //     .then(() => {
  //       toast.success("FAQs saved successfully", toastAttr);
  //       history.push("/cms/faqs");
  //       setLoader(false);
  //     })
  //     .catch(() => {
  //       toast.error("Error saving FAQs", toastAttr);
  //       setLoader(false);
  //     });
  // };

  return (
    <Container className="vendor">
      <Row>
        <Col md={12} className="contBody">
          <Card>
            <CardBody className="theme-light">
              <div className="card__title pageNav">
                <div className="bold-text">
                  <Breadcrumbs data={breadcrumbData} />
                </div>
              </div>

              <Row className="formBtnsDiv mb-3">
                <Col md={12}>
                  <Button variant="primary" onClick={saveForm}>
                    Save
                  </Button>{" "}
                  <Button
                    variant="secondary"
                    onClick={() => history.push("/seobook/faqcontent")}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>

              <Form className="form defaultForm">
                <Loader loading={loading} overlay={overlay}>
                  {/* Page Type */}
                  <Row className="mb-3">
                    <Col md={2}>
                      <Form.Label>Page Type *</Form.Label>
                    </Col>
                    <Col md={6}>
                      <Select
                        options={pageOptions}
                        value={pageOptions.find(
                          (opt) => opt.value === form.page_type
                        )}
                        onChange={(selected) =>
                          handleInput("page_type", selected?.value || null)
                        }
                        isClearable
                         isDisabled={editMode}
                        className={errors.page_type ? "is-invalid" : ""}
                      />
                      {errors.page_type && (
                        <div className="text-danger">{errors.page_type}</div>
                      )}
                    </Col>
                  </Row>

                  {/* Mandap Dropdown */}
                 {/* Mandap Dropdown */}
{form.page_type === "mandap" && (
  <Row className="mb-3">
    <Col md={2}>
      <Form.Label>Select Mandap *</Form.Label>
    </Col>
    <Col md={6}>
      <Select
        options={mandaps}
        // Use String comparison to match form.mandap
        value={mandaps.find(
          (opt) => String(opt.value) === String(form.mandap)
        )}
        onChange={(selected) => {
          // Normalize value to number or null
          handleInput("mandap", selected?.value ?? null);
        }}
        isClearable
        isDisabled={editMode}
        isLoading={isLoadingMandaps} // show spinner
        placeholder={isLoadingMandaps ? "Loading mandaps..." : "Select mandap"}
      />
      {errors.mandap && (
        <div className="text-danger">{errors.mandap}</div>
      )}
    </Col>
  </Row>
)}



                  {/* FAQ Items */}
                  <h5 className="mt-4 mb-3">FAQ List</h5>
                  {form.faqs.map((faq, index) => (
                    <Card key={index} className="mb-3 p-3 border">
                      <Row>
                        <Col md={6}>
                          <Form.Label>Question *</Form.Label>
                          <Form.Control
                            type="text"
                            value={faq.question}
                            onChange={(e) =>
                              handleFaqChange(index, "question", e.target.value)
                            }
                            isInvalid={!!errors[`faq_${index}`]}
                          />
                        </Col>
                        <Col md={6}>
                          <Form.Label>Answer *</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            value={faq.answer}
                            onChange={(e) =>
                              handleFaqChange(index, "answer", e.target.value)
                            }
                            isInvalid={!!errors[`faq_${index}`]}
                          />
                        </Col>
                      </Row>

                      <div className="mt-2 text-end">
                        {form.faqs.length > 1 && (
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => removeFaq(index)}
                          >
                            <FaMinusCircle size={14} /> Remove
                          </Button>
                        )}
                      </div>
                    </Card>
                  ))}

                  <Button variant="success" onClick={addFaq}>
                    <FaPlus size={16} /> Add FAQ
                  </Button>

                  {/* Active Switch */}
                  <Row className="mt-4 mb-3">
                    <Col md={2}>
                      <Form.Label>Active *</Form.Label>
                    </Col>
                    <Col md={2}>
                      <Form.Check
                        type="switch"
                        label=""
                        checked={form.is_active}
                        onChange={(e) =>
                          handleInput("is_active", e.target.checked)
                        }
                      />
                    </Col>
                  </Row>
                </Loader>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <ToastContainer />
    </Container>
  );
};

export default FaqcontentForm;
